/** Zoho onboarding groups — pipeline order for filters and stepper. */
export const ONBOARDING_GROUP_KEYS = [
  'onboardingSent',
  'onboardingSubmitted',
  'paSigned',
  'onboardingCompleted',
  'onboardingDenied'
];

/** Default table view: pending onboardings only (excludes approved + denied). */
export const DEFAULT_STATUS_FILTERS = [
  'onboardingSent',
  'onboardingSubmitted',
  'paSigned'
];

export const GROUP_TAB_KEYS = ['all', ...ONBOARDING_GROUP_KEYS];

export const ONBOARDING_STEP_DEFS = [
  { key: 'onboardingSent', label: 'Onboarding Sent to Agent' },
  { key: 'onboardingSubmitted', label: "Onboarding Submitted to O'Neill" },
  { key: 'paSigned', label: 'Producer Agreement Signed' },
  { key: 'onboardingCompleted', label: 'Onboarding Approved' }
];

export const TAB_LABELS = {
  all: 'All statuses',
  onboardingSent: 'Onboarding Sent to Agent',
  onboardingSubmitted: "Onboarding Submitted to O'Neill",
  paSigned: 'Producer Agreement Signed',
  onboardingCompleted: 'Onboarding Approved',
  onboardingDenied: 'Onboarding Denied'
};

/** Filter table rows by `onboardingPayloadAgencyId` matching multiselect agency id */
export const RESPONSE_AGENCY_FILTER_ALL = 'all';

/** Sentinel agency-filter option value for rows with a blank/missing relatedToAgency. */
export const ONBOARDING_EMPTY_AGENCY = '__emptyAgency__';
